import { useEffect, useMemo, useState } from "react";
import SideNavLayout from "../customsidenav/sidenavlayout";
import {
  approved,
  calendericon,
  clock,
  leftarrow,
  needbenifi,
  rejected,
  rightarrow,
} from "./svg/iconsvg";
import StatusCard from "./statuscard";
import ProfileCard from "./modals/profilecard";
import BenefitsApprovalModal from "./modals/benifitsmodal";
import LegendModal from "./modals/legendModal";
import FilterModal from "./modals/filtermodal";
import ToastMessage from "../utils/mui/righttoptoast";
import api from "../api/api";

import {
  Backdrop,
  CircularProgress,
  Chip,
  ClickAwayListener,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useSelector } from "react-redux";
import EditBalanceCard from "./modals/editbalances";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/* -------------------- Styled Calendar -------------------- */
const CustomDateCalendar = styled(DateCalendar)(() => ({
  borderRadius: "13px",
  boxShadow: "0 4px 4px rgba(0,0,0,0.25)",
  backgroundColor: "#fff",
  "& .MuiPickersCalendarHeader-label": {
    fontSize: "15px",
  },
  "& .MuiPickersDay-root.Mui-selected": {
    backgroundColor: "#1D2951",
    color: "#fff",
  },
}));

/* -------------------- Component -------------------- */
const ColorCoding = () => {
  /* ---------- Global ---------- */
  const practiseid = window.getPracticeId();
  const userConfig = useSelector((state) => state.userconfig);

  /* ---------- UI State ---------- */
  const [activeTab, setActiveTab] = useState("needBenefits");
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const[editbalancesopen,setEditbalancesopen]=useState(false);  
  const [isBenefitsOpen, setIsBenefitsOpen] = useState(false);
  const [isLegendOpen, setIsLegendOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
const [search, setSearch] = useState("");
  /* ---------- Data ---------- */
  const [data, setData] = useState([]);
  const [backupData, setBackupData] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState(null);

  /* ---------- Filters ---------- */
  const [filters, setFilters] = useState({
    timeOfDay: "",
    provider: "",
  });

  /* ---------- Date ---------- */
  const [selectedDate, setSelectedDate] = useState(null);

  /* ---------- Loaders ---------- */
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  /* ---------- Toast ---------- */
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [severity, setSeverity] = useState("success");

  const handleToastClose = () => setOpenToast(false);

  /* ---------- Helpers ---------- */
  const colors = {
    A: "#22C55E",
    P: "#FBBF24",
    R: "#EF4444",
  };

  const hasReferenceNumber = (item) =>
    item?.ins_config &&
    Object.prototype.hasOwnProperty.call(item.ins_config, "referencenumber") &&
    String(item.ins_config.referencenumber || "").trim() !== "";

  /* -------------------- API -------------------- */
  const fetchdata = async () => {
    try {
      setLoading(true);

      const params = {};
      if (selectedDate) {
        params.startdate = dayjs(selectedDate).format("YYYY-MM-DD");
      }

      const response = await api.get(
        `/v1/${practiseid}/patients/insurance/get-all`,
        { params }
      );

      const result = response.status === 200 ? response.data || [] : [];
      setData(result);
      setBackupData(result);
    } catch (error) {
      console.error(error);
      setData([]);
      setBackupData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "CHIM - Color Coding";
    fetchdata();
  }, [selectedDate]);
useEffect(() => {
  setSearch("");
}, [activeTab, filters]);
  /* -------------------- Tabs -------------------- */
  const tabs = useMemo(
    () => [
      {
        key: "pending",
        label: "Pending",
        icon: clock,
        count: backupData.filter((i) => i.ins_status === "P").length,
      },
      {
        key: "approved",
        label: "Approved",
        icon: approved,
        count: backupData.filter((i) => i.ins_status === "A").length,
      },
      {
        key: "rejected",
        label: "Rejected",
        icon: rejected,
        count: backupData.filter((i) => i.ins_status === "R").length,
      },
      {
        key: "needBenefits",
        label: "Need Benefits",
        icon: needbenifi,
        count: backupData.filter((i) => !hasReferenceNumber(i)).length,
      },
    ],
    [backupData]
  );

  /* -------------------- Filters -------------------- */
  const clearAllFilters = () =>
    setFilters({ timeOfDay: "", provider: "" });

  const clearSingleFilter = (key) =>
    setFilters((prev) => ({ ...prev, [key]: "" }));

  /* -------------------- Filtered Data -------------------- */
  const filteredData = useMemo(() => {
    let result = [];

    switch (activeTab) {
      case "pending":
        result = backupData.filter((i) => i.ins_status === "P");
        break;
      case "approved":
        result = backupData.filter((i) => i.ins_status === "A");
        break;
      case "rejected":
        result = backupData.filter((i) => i.ins_status === "R");
        break;
      case "needBenefits":
        result = backupData.filter((i) => !hasReferenceNumber(i));
        break;
      default:
        result = backupData;
    }

    if (filters.timeOfDay) {
      result = result.filter((i) => {
        if (!i.appointment_time) return false;
        const hour = Number(i.appointment_time.split(":")[0]);
        return filters.timeOfDay === "morning" ? hour < 12 : hour >= 12;
      });
    }

    if (filters.provider) {
      result = result.filter(
        (i) => i.provider_name === filters.provider
      );
    }
      if (search) {
    const term = search.toLowerCase();

  result = result.filter((i) => {
  const fullName = `${i.firstname || ""} ${i.lastname || ""}`.toLowerCase();
  const phone = String(i.phone_number || i.mobile || "").toLowerCase();

  return fullName.includes(term) || phone.includes(term);
});
  }

    return result;
  }, [activeTab, backupData, filters,search]);

  /* -------------------- Save Config -------------------- */
  const saveconfig = async (payload) => {
    try {
      setIsSaving(true);

      const response = await api.put(
        `/v1/${practiseid}/patients/${payload.patientid}/insurance/update`,
        {
          ins_status: payload.ins_status,
          ins_config: payload.ins_config,
        }
      );

      if (response.status === 200) {
        setToastMessage("Details added successfully");
        setSeverity("success");
        fetchdata();
        if (payload.isexit) setIsProfileOpen(false);
      } else {
        throw new Error();
      }
    } catch {
      setToastMessage("Failed to add details");
      setSeverity("error");
    } finally {
      setOpenToast(true);
      setIsSaving(false);
    }
  };

  /* -------------------- Change Status -------------------- */
  const changestatus = async (payload) => {
    try {
      setIsSaving(true);

      const response = await api.put(
        `/v1/${practiseid}/patients/${payload.patientid}/insurance/status?status=${payload.status}`
      );

      if (response.status === 200) {
        setToastMessage(
          `Patient ${payload.status === "A" ? "Approved" : "Rejected"} successfully`
        );
        setSeverity("success");
        fetchdata();
        setIsProfileOpen(false);
        setIsBenefitsOpen(false);
        setEditbalancesopen(false)
      } else {
        throw new Error();
      }
    } catch {
      setToastMessage("Failed to update status");
      setSeverity("error");
    } finally {
      setOpenToast(true);
      setIsSaving(false);
    }
  };

  /* -------------------- Render -------------------- */
  return (
    <SideNavLayout>
      <div className="flex flex-col relative">

        {/* Header */}
        <div className="flex justify-between items-center">
          <h1 className="text-[20.4px] font-bold text-[#1D2951]">
            Color Coding
          </h1>

         <div className="flex gap-2 items-center">

  {/* Search */}
  <div className="relative">
    <FontAwesomeIcon
      icon={faSearch}
      className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"
    />

    <input
      type="text"
      placeholder="Search patient..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="pl-9 pr-3 py-2 w-[230px] border border-gray-300 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-[#50869A]"
    />
  </div>

  {/* Filters */}
  <button
    onClick={() => setIsFilterOpen(true)}
    disabled={!backupData.length}
    className={`px-4 py-2 rounded text-white text-sm ${
      backupData.length
        ? "bg-[#50869A]"
        : "bg-gray-300 cursor-not-allowed"
    }`}
  >
    Filters
  </button>

  {/* Legend */}
  <button
    onClick={() => setIsLegendOpen(true)}
    className="px-4 py-2 rounded bg-[#4B5563] text-white text-sm"
  >
    Legend
  </button>

</div>
        </div>

        {/* Tabs + Calendar */}
        <div className="mt-4 flex justify-between border-b">
          <div className="flex flex-row gap-6 text-sm">
            {tabs.map((tab) => (
         <button
        key={tab.key}
        onClick={() => setActiveTab(tab.key)}
        className={`pb-2 flex items-center gap-2 whitespace-nowrap ${
          activeTab === tab.key
            ? "border-b-2 border-[#50869A] font-medium text-[#09090B]"
            : "text-gray-500"
        }`}
      >
                {tab.icon} {tab.label} ({tab.count})
              </button>
            ))}
          </div>

          <div className="flex items-center gap-3 text-sm relative">
            <button
              onClick={() =>
    setSelectedDate(
      (selectedDate || dayjs().add(1, "day")).subtract(1, "day")
    )
  }
            >
              {leftarrow}
            </button>

            {!selectedDate ? (
                <button onClick={() => setIsCalendarOpen(true)}>
  {dayjs().add(1, "day").format("MM-DD-YYYY")}
</button>
            ) : (
              <Chip
                size="small"
                label={dayjs(selectedDate).format("MM-DD-YYYY")}
                onDelete={() => setSelectedDate(null)}
                onClick={() => setIsCalendarOpen(true)}
              />
            )}

            <button onClick={() => setIsCalendarOpen(true)}>
              {calendericon}
            </button>

            <button
           onClick={() =>
    setSelectedDate(
      (selectedDate || dayjs().add(1, "day")).add(1, "day")
    )
  }
            >
              {rightarrow}
            </button>

            {isCalendarOpen && (
              <ClickAwayListener
                onClickAway={() => setIsCalendarOpen(false)}
              >
                <div className="absolute right-0 top-10 z-50">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <CustomDateCalendar
                      value={selectedDate || dayjs()}
                      onChange={(newDate) => {
                        setSelectedDate(newDate);
                        setIsCalendarOpen(false);
                      }}
                    />
                  </LocalizationProvider>
                </div>
              </ClickAwayListener>
            )}
          </div>
        </div>

        {/* Active Filters */}
        {(filters.provider || filters.timeOfDay) && (
          <div className="mt-3 flex gap-2 flex-wrap">
            {filters.provider && (
              <Chip
                label={`Provider: ${filters.provider}`}
                onDelete={() => clearSingleFilter("provider")}
              />
            )}
            {filters.timeOfDay && (
              <Chip
                label={
                  filters.timeOfDay === "morning"
                    ? "Morning Appointments"
                    : "Afternoon Appointments"
                }
                onDelete={() => clearSingleFilter("timeOfDay")}
              />
            )}
            {filters.provider && filters.timeOfDay && (
              <Chip
                label="Clear All"
                color="error"
                onDelete={clearAllFilters}
              />
            )}
          </div>
        )}

        {/* Cards */}
        <div className="mt-4 max-h-[420px] overflow-y-auto flex flex-col gap-3">
          {filteredData.length ? (
            filteredData.map((item) => (
              <StatusCard
                key={item.patientid}
                item={item}
                colors={colors}
                activeTab={activeTab}
                onProfileClick={() => {
                  setSelectedProfile(item);
                
  //                 if(activeTab === "pending"){
  //  setEditbalancesopen(true)
  
  //                 }else{
                    
  //                   setIsProfileOpen(true);
  //                 }
                  
                }}
                onOpenBenefits={() => {
                  setSelectedProfile(item);
                  setIsBenefitsOpen(true);
                }}
              />
            ))
          ) : (
            <div className="text-center text-gray-500 py-10">
              No data available
            </div>
          )}
        </div>
      </div>

      {/* Modals */}
      <ProfileCard
        isOpen={isProfileOpen}
        profile={selectedProfile}
        colors={colors}
        onClose={() => setIsProfileOpen(false)}
        onSave={saveconfig}
      />
     <EditBalanceCard
        isOpen={editbalancesopen}
        profile={selectedProfile}
        colors={colors}
        onClose={() => setEditbalancesopen(false)}
        onSave={saveconfig}
           changestatus={changestatus}
      />
      <BenefitsApprovalModal
        isOpen={isBenefitsOpen}
        profile={selectedProfile}
        colors={colors}
        changestatus={changestatus}
        onSave={saveconfig}
        onClose={() => setIsBenefitsOpen(false)}
      />

      <FilterModal
        isOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        onApply={(f) => setFilters(f)}
        data={backupData}
      />

      <LegendModal
        isOpen={isLegendOpen}
        onClose={() => setIsLegendOpen(false)}
      />

      <ToastMessage
        open={openToast}
        message={toastMessage}
        severity={severity}
        handleClose={handleToastClose}
      />

      {/* Loader */}
      <Backdrop
        sx={{
          color: "#fff",
          backgroundColor: "rgba(0,0,0,0.6)",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading || isSaving}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </SideNavLayout>
  );
};

export default ColorCoding;
